import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  createSendingProfile,
  deleteSendingProfile,
  fetchSendingProfiles,
  setSendingProfileCredentials,
  updateSendingProfile,
  type SendingProfileCreateBody,
  type SendingProfileCredentialsBody,
  type SendingProfileUpdateBody,
} from "../api/sendingProfiles";

export function useSendingProfiles() {
  return useQuery({
    queryKey: ["sending-profiles"],
    queryFn: fetchSendingProfiles,
  });
}

export function useCreateSendingProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SendingProfileCreateBody) => createSendingProfile(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["sending-profiles"] });
    },
  });
}

export function useUpdateSendingProfile(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SendingProfileUpdateBody) => updateSendingProfile(id, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["sending-profiles"] });
    },
  });
}

export function useDeleteSendingProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteSendingProfile(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["sending-profiles"] });
    },
  });
}

export function useSetSendingProfileCredentials(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SendingProfileCredentialsBody) =>
      setSendingProfileCredentials(id, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["sending-profiles"] });
    },
  });
}
